module.exports = __webpack_public_path__ + "img/gentlemen-club-team-1.b129da6f.png";